import { render, staticRenderFns } from "./article-simple.vue?vue&type=template&id=ca7186b8&scoped=true"
import script from "./article-simple.vue?vue&type=script&lang=js"
export * from "./article-simple.vue?vue&type=script&lang=js"
import style0 from "./article-simple.vue?vue&type=style&index=0&id=ca7186b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7186b8",
  null
  
)

export default component.exports